var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgOrangeBlueGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 168,
    viewBox: "0 0 1080 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_323_1524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1080,
    height: 168
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 168,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_323_1524)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_323_1524)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 438,
    cy: -395.727,
    rx: 371,
    ry: 438.455,
    fill: "#FFA23D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_323_1524)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 643,
    cy: -395.727,
    rx: 371,
    ry: 438.455,
    fill: "#C1E0FE"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_323_1524",
    x: -53,
    y: -954.182,
    width: 982,
    height: 1116.91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_323_1524"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_323_1524",
    x: 152,
    y: -954.182,
    width: 982,
    height: 1116.91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_323_1524"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgOrangeBlueGradient);
export default __webpack_public_path__ + "static/media/bg-orange-blue-gradient.4db1a3d9f66ed274a5fe2ca2cf74910f.svg";
export { ForwardRef as ReactComponent };